import React, { useEffect, useState } from 'react'
import { SnackbarContainer, SnackbarText } from './Snackbar.styles.tsx'

export interface SnackbarProps {
  message: string
  duration?: number // in milliseconds
  isVisible?: boolean
  onClose?: () => void
  textAlign?: 'left' | 'center' | 'right'
  width?: string
}

const Snackbar: React.FC<SnackbarProps> = ({
  message,
  duration = 3000,
  isVisible = false,
  onClose,
  textAlign = 'center',
  width = '120px'
}) => {
  const [visible, setVisible] = useState(isVisible)

  useEffect(() => {
    setVisible(isVisible)

    if (isVisible) {
      const timer = setTimeout(() => {
        setVisible(false)
        if (onClose) onClose()
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [isVisible, duration, onClose])

  if (!visible) return null

  return (
    <SnackbarContainer style={{ width }}>
      <SnackbarText $textAlign={textAlign}>{message}</SnackbarText>
    </SnackbarContainer>
  )
}

export default Snackbar
